var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMarketRightTickLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.829 18.833",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_guarantee_3073205_000000",
    d: "M9.417-.012A2.97,2.97,0,0,0,7.5.7,5.068,5.068,0,0,1,6.18,1.6a5.054,5.054,0,0,1-1.572.286A2.954,2.954,0,0,0,1.9,4.6a5.043,5.043,0,0,1-.291,1.572A5.085,5.085,0,0,1,.7,7.494a2.955,2.955,0,0,0,0,3.827,5.044,5.044,0,0,1,.908,1.316A5.069,5.069,0,0,1,1.9,14.213a2.955,2.955,0,0,0,2.706,2.707,5.063,5.063,0,0,1,1.572.291,5.068,5.068,0,0,1,1.32.908,2.955,2.955,0,0,0,3.827,0,5.085,5.085,0,0,1,1.321-.908,5.063,5.063,0,0,1,1.572-.291,2.956,2.956,0,0,0,2.707-2.707,5.089,5.089,0,0,1,.291-1.576,5.044,5.044,0,0,1,.908-1.316,2.955,2.955,0,0,0,0-3.827,5.085,5.085,0,0,1-.908-1.321A5.062,5.062,0,0,1,16.927,4.6,2.956,2.956,0,0,0,14.22,1.89,5.055,5.055,0,0,1,12.648,1.6,5.068,5.068,0,0,1,11.328.7,2.957,2.957,0,0,0,9.417-.012Zm3.5,6.441a.588.588,0,0,1,.431,1.008L8.574,12.211a.59.59,0,0,1-.835,0L5.482,9.952a.588.588,0,1,1,.834-.83l1.842,1.842,4.356-4.356a.586.586,0,0,1,.4-.178Z",
    transform: "translate(0 0.012)",
    fill: "#569a4d"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketRightTickLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/market-right-tick-logo.31942ffb.svg";
export { ForwardRef as ReactComponent };